export default function increase(prev) {
  return ++prev;
}
